/*
 * A purchase's figures (E1 `purchases[]`, E5 `purchase`; R-03-06) → what the
 * screens show beside the session count. Already computed by the backend — the
 * quota is per week and present only while a payment is pending, so there is no
 * arithmetic here.
 */

/**
 * @param {object|null} raw
 * @returns {{masterOrderId: string, isFlex: boolean, paidSessions: number,
 *            completedSessions: number, capacityRemaining: number,
 *            extraCreditsUnallocated: number, permittedPerWeek: number|null,
 *            scheduledPerWeek: number|null}|null}
 */
export const purchaseMapper = (raw) =>
  raw
    ? {
        masterOrderId: raw?.masterOrderId,
        isFlex: raw?.kind === "flex",
        paidSessions: raw?.paidSessions ?? 0,
        completedSessions: raw?.completedSessions ?? 0,
        capacityRemaining: raw?.capacityRemaining ?? 0,
        extraCreditsUnallocated: raw?.extraCreditsUnallocated ?? 0,
        permittedPerWeek: raw?.quota?.permittedPerWeek ?? null,
        scheduledPerWeek: raw?.quota?.scheduledPerWeek ?? null,
      }
    : null;
